module.exports = __webpack_public_path__ + "img/bars.5e9fe169.svg";